import Icon from '../components/Icon.vue'

Icon.register({
  tree: {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M378.3 378.5L298.4 288H329.1C338.1 288 346 283 349.8 274.9 353.6 266.9 352.4 257.7 346.6 250.9L268.4 160H297.3C306.4 160 314.6 154.6 318.2 146.4 321.7 138.3 320 128.8 313.9 122.3L203.7 4.8C197.6-1.6 186.4-1.6 180.3 4.8L70.1 122.3C64 128.8 62.3 138.3 65.8 146.4 69.4 154.6 77.6 160 86.7 160H115.6L37.4 250.9C31.6 257.7 30.4 266.9 34.2 274.9 38 283 45.9 288 55 288H85.6L5.7 378.5C-0.3 385.3-1.7 394.6 2.1 402.8 5.9 410.8 14.1 416 23.1 416H160V440.4L129.7 488.9C124.4 499.5 132.1 512 144 512H240C251.9 512 259.6 499.5 254.3 488.9L224 440.4V416H360.9C369.9 416 378.1 410.8 381.9 402.8 385.7 394.6 384.3 385.3 378.3 378.5z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/tree.js
// module id = JkcP
// module chunks = 144